import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor() { }
  
  isArabic : boolean = false ;
  
  socials = [
    {icon : 'fa-brands fa-facebook' , link : 'https://www.facebook.com/hurghadaradio'} ,
    {icon : 'fa-brands fa-instagram' , link : 'https://www.instagram.com/hurghadaradio'} ,
    {icon : 'fa-brands fa-tiktok' , link : 'https://www.tiktok.com/@hurghadaradio'} ,
    {icon : 'fa-brands fa-youtube' , link : 'http://www.youtube.com/@hurghadaradiostation'} ,
  ]
  
}
